<template>
  <el-form size="mini" v-model="fromSummit">
    <el-form-item label="等级">
      <el-input placeholder="起始等级" size="mini" style="width: 68px;" v-model="fromSummit.fromPoint"></el-input>
      -
      <el-input placeholder="结束等级" size="mini" style="width:68px;" v-model="fromSummit.toPoint"></el-input>
      <span style="padding-left: 10px;">
          <label style="padding-right: 10px;">报价文本包含预计时间</label>
             <el-switch
               v-model="fromSummit.showTime"
             >
      </el-switch>
        </span>
    </el-form-item>

  </el-form>
</template>

<script>
  export default {
    name: 'Summit',
    data () {
      return {
        gameId: 59,
        fromSummit: {
          fromPoint: '',
          toPoint: '',
          showTime: true,
          inscriptionId: 0,
          inscriptions: []
        }
      }
    },
    mounted () {

    },
    methods: {
    }
  }
</script>

<style scoped>

</style>
